import Axios from "@/plugins/axios";

export default {
  namespaced: true,

  state: {
    sms: false,
    lines: [],
    error: false
  },
  getters: {
    sms: state => state.sms,
    lines: state => state.lines,
    error: state => state.error
  },
  mutations: {
    SET_SMS: (state, payload) => state.sms = payload,
    SET_LINES: (state, payload) => state.lines = payload,
    SET_ERROR: (state, error) => state.error = error
  },
  actions: {
    all: async ({ commit }, payload) => {
      try {
        const response = await Axios.get("/api/external-lines", payload);
        commit("SET_SMS", response.data.has_sms);
        commit("SET_LINES", response.data.lines);
      } catch (e) {
        commit("SET_ERROR", e);
      }
    },

    clear: async ({ commit }) => {
      commit("SET_LINES", []);
    }
  }
};